import apiClient from './apiClient';

class UserService {
  // Get all admin users
  static async getAllUsers(params = {}) {
    try {
      const response = await apiClient.get('/admin/users', { params });
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.error?.message || error.response?.data?.message || 'Failed to fetch users',
        error: error.response?.data?.error
      };
    }
  }

  // Get single admin user
  static async getUser(userId) {
    try {
      const response = await apiClient.get(`/admin/users/${userId}`);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch user'
      };
    }
  }

  // Create new admin user
  static async createUser(userData) {
    try {
      const response = await apiClient.post('/admin/users', userData);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to create user'
      };
    }
  }

  // Update admin user
  static async updateUser(userId, userData) {
    try {
      const response = await apiClient.put(`/admin/users/${userId}`, userData);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update user'
      };
    }
  }

  // Delete admin user
  static async deleteUser(userId) {
    try {
      const response = await apiClient.delete(`/admin/users/${userId}`);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to delete user'
      };
    }
  }

  // Update user status
  static async updateUserStatus(userId, status) {
    try {
      const response = await apiClient.put(`/admin/users/${userId}/status`, { status });
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update user status'
      };
    }
  }

  // Reset user password
  static async resetUserPassword(userId, sendEmail = true) {
    try {
      const response = await apiClient.post(`/admin/users/${userId}/reset-password`, { sendEmail });
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to reset password'
      };
    }
  }

  // Get user permissions
  static async getUserPermissions(userId) {
    try {
      const response = await apiClient.get(`/admin/users/${userId}/permissions`);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch user permissions'
      };
    }
  }

  // Bulk assign roles
  static async bulkAssignRoles(userIds, roleId) {
    try {
      const response = await apiClient.post('/admin/users/bulk/assign-roles', { userIds, roleId });
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to assign roles'
      };
    }
  }

  // Get role statistics
  static async getRoleStats() {
    try {
      const response = await apiClient.get('/admin/users/stats/roles');
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch role statistics'
      };
    }
  }
}

export default UserService;